<template>

  <div class="container-fluid loginPages p-0">
    <div class="container py-4">
        <div class="row d-block m-0">
            <img src="static/images/logo.png" class="img-fluid">
            <router-link class="saas-btn mt-0 float-right" to="/login">{{$ml.get('LOGIN')}}</router-link>
          </div>
    </div>
    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">
    <div class="container mt-3 mb-5">
        <div class="row loginInfo">
            <div class="col-12 col-md-6 text-center">
            <img src="@/assets/sifremi-unuttum.png" class="img-fluid">
            </div>
            <div class="col-12 col-md-6 mt-4 mt-md-0">

            <h2 class="title">{{$ml.get('RESET_PASSWORD')}}</h2>
            <div class="mt-3">
              
                <form class="login-form saas-form" v-on:submit.prevent="login">

                  <div class="saas-form-control" :class="{isDanger:passwordError.state==true}">
                    <label for="password" class="saas-label">{{$ml.get('PASSWORD')}}</label>
                    <input type="password" @input="passwordValidation" class="saas-input" v-model="password">
                    <div class="col-12 d-block input-error px-0">
                      <span class="alert-input" v-if="passwordError.state">{{passwordError.message}}</span>
                    </div>
                  </div>

                  <div class="saas-form-control" :class="{isDanger:rPasswordError.state==true}">
                    <label for="password" class="saas-label">{{$ml.get('PASSWORD_REPEAT')}}</label>
                    <input type="password" @input="rPasswordValidation" class="saas-input" v-model="rePassword">
                    <div class="col-12 d-block input-error px-0">
                      <span class="alert-input" v-if="rPasswordError.state">{{rPasswordError.message}}</span>
                    </div>
                  </div>

                   <!-- Password renew button not working -->
                  <input type="submit" class="saas-btn mt-3" :value="$ml.get('RENEW_PASSWORD')" >
                  <router-link class="saas-btn saas-btn-transparent mt-3 saas-btn ml-3" to="/login">{{$ml.get('CANCEL')}}</router-link>
                  
                </form>

                
            </div>
            </div>
        </div>
    </div>
    <notifications group="foo" style="margin-right:5%;margin-top:5%" position="top right" />

    <Footer></Footer>
  </div>

</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import { mapActions } from "vuex";
import Footer from './footer.vue'
export default {
  name: "Login",
  data() {
    return {
      password: "",
      rePassword: "",
      passwordError:{state:false,message:''},
      rPasswordError:{state:false,message:''},
    };
  },
  computed: {
    ...mapState(["baseUrl"])
  },
  components:{
      Footer
  },
  methods: {
    login() {
          
      this.passwordValidation()
      this.rPasswordValidation()
      if(
          !this.passwordValidation() || 
          !this.rPasswordValidation()
      ){
          return false
      }
       
      axios({
          method:'POST',
          url:'/resetPassword',
          baseURL: this.baseUrl,
          data: {
            resetCode:this.$route.query.resetCode,
            password:this.password
          },
          withCredentials:true
          }).then((res)=>{
              return res
          }).then((res)=>{
          if(res.data.status.code==0){
            this.$notify({ 
                group: 'foo',
                type: 'success',
                delay:6000,
                title: this.$ml.get('SUCCESS_PASSWORD_UPDATED'),
                text: res.data.status.desc 
            })
            setTimeout(() => {
                this.$router.push("/login");
            }, 3000);
            
          }else{
            this.$notify({ 
                group: 'foo',
                type: 'error', 
                title: this.$ml.get('ERROR'),
                text: res.data.status.desc 
            })
          }
        })
    },
    passwordValidation(){
        this.passwordError.messages = []
        this.passwordError.state = false
        if(this.password==''){
            this.passwordError.message=this.$ml.get('PLEASE_SET_PASSWORD')
            this.passwordError.state = true
            return false
        }else{
          return true
        }
    },
    rPasswordValidation(){
        this.rPasswordError.message = ""
        this.rPasswordError.state = false
        
        if(this.rePassword==''){
            this.rPasswordError.message = this.$ml.get('PLEASE_RE_ENTER_PASSWORD')
            this.rPasswordError.state = true
            return false
        }else if(this.password!==this.rePassword){
            this.rPasswordError.message = this.$ml.get('PASSWORD_DO_NOT_MATCH')
            this.rPasswordError.state = true
            return false
        }else{
            this.rPasswordError.state = false
            return true
        }
        
    },
    ...mapActions(["updateLoading"])
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 body{
      background-color: #E5E5E5 !important;
      color: #677294;
    }
  .form-check{
    padding-top: 0.5rem;
    padding-left: 0rem;
  }
.form-check label{
  cursor: pointer;
  line-height: 25px;
}
  h1{
    color: white;
  }
  .form-check{
    font-size: 0.9rem;
  }
</style>
